import { render, staticRenderFns } from "./ItemRed.vue?vue&type=template&id=e5d26e98&scoped=true&"
import script from "./ItemRed.vue?vue&type=script&lang=js&"
export * from "./ItemRed.vue?vue&type=script&lang=js&"
import style0 from "./ItemRed.vue?vue&type=style&index=0&id=e5d26e98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d26e98",
  null
  
)

export default component.exports